import * as lib from 'Root/lib/lib.js'

const FAQ_ACTIVE_CLASS = 'active'

class FaqsList {
    constructor(element) {
        if (!element) return

        this.element = element

        this._iniFaqsAccordion()

        this._iniSideLinksMobile()

        this._iniSideLinksNav()
    }

    _iniFaqsAccordion() {
        this.element.querySelectorAll('.b-faq__head').forEach((item) => {
            item.addEventListener('click', (e) => {
                const faqItem = e.currentTarget.parentNode

                if (!faqItem.classList.contains(FAQ_ACTIVE_CLASS)) {
                    this.expandItem(faqItem)
                } else {
                    this.collapseItem(faqItem)
                }
            })
        })
    }

    expandItem(item) {
        item.classList.add(FAQ_ACTIVE_CLASS)
        $(item.querySelector('.b-faq__body')).slideDown(300, () => {
            lib.moveWindowToObj($(item), -10)
        })
    }

    collapseItem(item) {
        item.classList.remove(FAQ_ACTIVE_CLASS)
        $(item.querySelector('.b-faq__body')).slideUp()
    }

    _iniSideLinksMobile() {
        this.sideLinks = this.element.querySelector('.b-side-links')

        if (!this.sideLinks) {
            return
        }

        this.sideLinksHead = this.sideLinks.querySelector('.b-side-links__head')
        this.sideLinksBody = this.sideLinks.querySelector('.b-side-links__body')

        this._setSideLinksHeadExpandedHeight()
        this._checkStickySideLinks()

        window.addEventListener('resize', () => {
            this._checkStickySideLinks()

            if (this.sideLinks.classList.contains('expanded')) {
                this.expandSideLinks()
            }
        })

        window.addEventListener('scroll', () => {
            this._checkStickySideLinks()
        })

        this.sideLinksHead.addEventListener('click', () => {
            if (!this.sideLinks.classList.contains('expanded')) {
                this.expandSideLinks()
            } else {
                this.collapseSideLinks()
            }
        })
    }

    expandSideLinks() {
        this.sideLinks.classList.add('expanded')

        const headerHeight = document.querySelector('.header__bar').offsetHeight
        const offset = window.innerWidth < lib.breakpoints.tablet ? 40 : 60
        const contHeight = window.innerHeight - headerHeight - this.sideLinksHeadExpandedHeight - offset

        this.sideLinksBody.style.height = `${contHeight}px`
    }

    collapseSideLinks() {
        this.sideLinks.classList.remove('expanded')
        this.sideLinksBody.style.height = 0
    }

    _setSideLinksHeadExpandedHeight() {
        this.sideLinks.classList.add('no-transition')

        setTimeout(() => {
            this.sideLinks.classList.add('calculating')
            this.sideLinksHeadExpandedHeight = this.sideLinksHead.offsetHeight
            this.sideLinks.classList.remove('calculating')

            setTimeout(() => {
                this.sideLinks.classList.remove('no-transition')
            })
        })
    }

    _iniSideLinksNav() {
        this.element.querySelectorAll('.b-side-links__list a').forEach((i) => {
            i.addEventListener('click', (e) => {
                e.preventDefault()
                const targetId = e.currentTarget.getAttribute('href')

                if (this.element.querySelector(targetId)) {
                    this.expandItem(this.element.querySelector(targetId))
                    this.collapseSideLinks()
                }
            })
        })
    }

    _checkStickySideLinks() {
        const $container = $(this.element).find('.s-faqs__cont')
        const sideLinksHeight = this.sideLinks.offsetHeight

        if (window.innerWidth >= lib.breakpoints.desktop) {
            $container.css('padding-bottom', 0)
            this.sideLinks.style.cssText = ''
        } else {
            $container.css('padding-bottom', sideLinksHeight + 25)

            const scrollTop = window.pageYOffset
            const winHeight = window.innerHeight
            const stickyBottomPos = window.innerWidth < lib.breakpoints.tablet ? 15 : 25
            const faqsBottom = $container.offset().top + $container.outerHeight()

            if (scrollTop + winHeight - stickyBottomPos > faqsBottom) {
                this.sideLinks.style.cssText = 'position: absolute; bottom: 0'
            } else {
                this.sideLinks.style.cssText = ''
            }
        }
    }
}

export default FaqsList
